// Events
import { COUNTDOWN_FINISHED } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';

export default component(async (node, ctx) => {
  const { endDate } = choozy(node);

  if (endDate) {
    ctx.on(COUNTDOWN_FINISHED(endDate.dataset.endDate), () => {
      window.location.reload();
    });
  }
});
